// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
// Constants
import { URLConstants } from '../../_constants/url-constants';
import { CacheDuration } from '../../_constants/cache-duration';
// Model imports
import { CashInvestmentReportResultDto } from '../_models/dashboard/cash-investment-report-result-dto';
import { AccountStandingReportResultDto } from '../_models/dashboard/account-standing-report-result-dto';
import { ExpenseBreakdownReportResultDto } from '../_models/dashboard/expense-breakdown-report-result-dto';
import { HomeOwnersWithOpenViolationsSummaryReportResultDto } from '../_models/dashboard/home-owners-with-open-violations-summary-report-result-dto';
import { BoardApprovalOpenItemCountResultDto } from '../_models/dashboard/board-approval-open-item-count-result-dto';
import { CommunityDashboardReportAccessResultDto } from '../_models/dashboard/community-dashboard-report-access-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class DashboardService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    getCashInvestment(data) {
        const url = `${URLConstants.ccCommunityApiBaseUrl}dashboard/cashinvestment${data.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, data.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(CashInvestmentReportResultDto, responseData)));
    }
    getAccountStatus(data) {
        const url = `${URLConstants.ccCommunityApiBaseUrl}dashboard/accountsstanding${data.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, data.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(AccountStandingReportResultDto, responseData)));
    }
    getExpenseBreakdown(data) {
        const url = `${URLConstants.ccCommunityApiBaseUrl}dashboard/expenses${data.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, data.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(ExpenseBreakdownReportResultDto, responseData)));
    }
    getHomeOwnersWithViolation(data) {
        const url = `${URLConstants.ccCommunityApiBaseUrl}dashboard/openviolations${data.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, data.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(HomeOwnersWithOpenViolationsSummaryReportResultDto, responseData)));
    }
    /**
     * Service method calling GET endpoint '/api/community/dashboard/board-approval/open' to get the open item counts for board approval
     * @returns Board approval open items count
     */
    getBoardApporvalOpenItemsCount(communityId) {
        const url = `${URLConstants.ccCommunityApiBaseUrl}dashboard/board-approval/open?communityId=${communityId}`;
        this.cacheRegistrationService.registerForCache(url, false);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((resposne) => plainToClass(BoardApprovalOpenItemCountResultDto, resposne)));
    }
    getDashboardReportAccess(data) {
        const url = `${URLConstants.ccCommunityApiBaseUrl}dashboard/report-access${data.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, data.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((responseData) => plainToClass(CommunityDashboardReportAccessResultDto, responseData)));
    }
}
DashboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardService_Factory() { return new DashboardService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: DashboardService, providedIn: "root" });
